@if (tenantService.tenantNotFound$ | async) {
  <black-tenant-not-found [subdomain]="tenantService.getTenantSubdomain() || tenantService.getTenantSlug()"></black-tenant-not-found>
} @else {
  <black-pwa-install-banner></black-pwa-install-banner>
  <black-impersonation-banner></black-impersonation-banner>
  <black-cookie-consent-banner></black-cookie-consent-banner>

  <div class="app-wrapper">
    <div class="app-header">
      <black-header></black-header>
    </div>
    <div class="app-body">
      <router-outlet></router-outlet>
    </div>
    <div class="app-footer">
      <black-footer></black-footer>
    </div>
  </div>
}

<black-ui-toast></black-ui-toast>
<ngx-spinner type="ball-scale-pulse"></ngx-spinner>
